/**
 * Shared constants for Lambda components
 */

// AWS Lambda orange color (#FF9900)
export const LAMBDA_ORANGE = '#FF9900';
export const LAMBDA_ORANGE_LIGHT = '#FFB84D';
